import React, { useState, useEffect, useRef } from 'react';

// ============================================
// Shared social embed components — used by the landing page (featured
// giveaway) and the Highlights page (curated social posts).
// True embeds for X/Twitter (widgets.js), Instagram (embed.js) and YouTube
// (player iframe); styled link cards for everything else and as automatic
// fallback when an embed fails to hydrate.
// ============================================

export const PLATFORMS = {
  twitter: { label: 'X', color: '#e4e4e7', path: 'M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z' },
  instagram: { label: 'Instagram', color: '#f472b6', path: 'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z' },
  youtube: { label: 'YouTube', color: '#f87171', path: 'M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z' },
  twitch: { label: 'Twitch', color: '#a855f7', path: 'M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.571 11.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714z' },
  tiktok: { label: 'TikTok', color: '#e4e4e7', path: 'M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z' },
  discord: { label: 'Discord', color: '#818cf8', path: 'M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z' }
};

export const PlatformChip = ({ platform }) => {
  const meta = PLATFORMS[platform] || { label: platform, color: '#a1a1aa', path: '' };
  return (
    <span className="lp-post-chip" style={{ color: meta.color }}>
      {meta.path && <svg viewBox="0 0 24 24" fill="currentColor"><path d={meta.path} /></svg>}
      {meta.label}
    </span>
  );
};

const loadScriptOnce = (src, id) => new Promise(resolve => {
  const existing = document.getElementById(id);
  if (existing) {
    if (existing.dataset.loaded) return resolve();
    existing.addEventListener('load', resolve);
    existing.addEventListener('error', resolve);
    return;
  }
  const s = document.createElement('script');
  s.id = id;
  s.src = src;
  s.async = true;
  s.onload = () => { s.dataset.loaded = '1'; resolve(); };
  s.onerror = resolve;
  document.body.appendChild(s);
});

// Warm up the embed hosts as soon as a post is on screen. Saves a DNS + TLS
// round trip per host, which is a decent chunk of the perceived delay.
const PRECONNECT_HOSTS = [
  'https://platform.twitter.com',
  'https://cdn.syndication.twimg.com',
  'https://pbs.twimg.com',
  'https://video.twimg.com'
];
let preconnected = false;
const ensurePreconnect = () => {
  if (preconnected || typeof document === 'undefined') return;
  preconnected = true;
  for (const href of PRECONNECT_HOSTS) {
    const l = document.createElement('link');
    l.rel = 'preconnect';
    l.href = href;
    l.crossOrigin = '';
    document.head.appendChild(l);
  }
};

const youtubeId = (url) => {
  const m = (url || '').match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/|live\/)|youtu\.be\/)([\w-]{6,})/);
  return m ? m[1] : null;
};

// Styled fallback card — used for non-embeddable platforms and when an embed fails to hydrate
export const PostCard = ({ post }) => (
  <a href={post.url} target="_blank" rel="noopener noreferrer" className="lp-post-card">
    {post.image_url && <div className="lp-post-img"><img src={post.image_url} alt="" loading="lazy" /></div>}
    <div className="lp-post-body">
      <PlatformChip platform={post.platform} />
      <h3 className="lp-post-title">{post.title}</h3>
      {post.description && <p className="lp-post-desc">{post.description}</p>}
      <span className="lp-post-go">View post →</span>
    </div>
  </a>
);

// Twitch clips appear as clips.twitch.tv/<slug>, twitch.tv/<user>/clip/<slug>
// or twitch.tv/clip/<slug>. Pull the slug out of any of them.
export const twitchClipSlug = (url = '') => {
  const m = String(url).match(/(?:clips\.twitch\.tv\/(?:embed\?clip=)?|twitch\.tv\/(?:[^/]+\/)?clip\/)([A-Za-z0-9_-]+)/i);
  return m ? m[1] : null;
};

// Each embed still has to fetch its own tweet from Twitter's syndication host
// (~350ms). Firing twenty at once means they queue behind the browser's
// per-host connection limit and the whole grid lands late together. Letting a
// few through at a time makes the top of the page appear almost immediately.
const HYDRATE_LIMIT = 4;
let hydrateActive = 0;
const hydrateQueue = [];
const acquireHydrateSlot = () => new Promise(resolve => {
  if (hydrateActive < HYDRATE_LIMIT) { hydrateActive++; resolve(); }
  else hydrateQueue.push(resolve);
});
const releaseHydrateSlot = () => {
  hydrateActive = Math.max(0, hydrateActive - 1);
  const next = hydrateQueue.shift();
  if (next) { hydrateActive++; next(); }
};

// Fetch widgets.js up front, while the visitor is still on whatever page they
// landed on. The script is a one-off ~100KB + DNS + TLS cost that used to be
// paid the moment someone opened Highlights; paying it during idle time means
// the embeds only have their own syndication fetch left to do (~350ms each).
export const preloadSocialEmbeds = () => {
  if (typeof window === 'undefined') return;
  ensurePreconnect();
  const go = () => loadScriptOnce('https://platform.twitter.com/widgets.js', 'lp-twitter-wjs');
  // Never compete with first paint — wait for the browser to be idle.
  if ('requestIdleCallback' in window) window.requestIdleCallback(go, { timeout: 4000 });
  else window.setTimeout(go, 2500);
};

// Placeholder shown while the platform script fetches and hydrates. Without it
// the raw <blockquote> fallback renders as a wall of unstyled blue links, which
// is the first thing visitors saw on a page holding a dozen embeds.
const EmbedSkeleton = () => (
  <div className="lp-embed-skel" aria-hidden="true">
    <div className="lp-skel-head">
      <span className="lp-skel-avatar" />
      <span className="lp-skel-lines">
        <span className="lp-skel-line short" />
        <span className="lp-skel-line tiny" />
      </span>
    </div>
    <span className="lp-skel-line" />
    <span className="lp-skel-line mid" />
    <div className="lp-skel-media" />
    <span className="lp-skel-line tiny" />
  </div>
);

export const SocialEmbed = ({ post }) => {
  const ref = useRef(null);
  const releaseSlotRef = useRef(null);
  const [failed, setFailed] = useState(false);
  const [hydrated, setHydrated] = useState(false);
  const [inView, setInView] = useState(false);
  const isTwitter = post.platform === 'twitter';
  const isInstagram = post.platform === 'instagram';
  const isScripted = isTwitter || isInstagram;

  // Only hydrate embeds that are near the viewport. Twelve at once is what made
  // the page crawl; this loads the first few and the rest as you scroll.
  useEffect(() => {
    if (!isScripted) return;
    const el = ref.current;
    if (!el) return;
    if (typeof IntersectionObserver === 'undefined') { setInView(true); return; }
    const io = new IntersectionObserver(entries => {
      if (entries.some(e => e.isIntersecting)) { setInView(true); io.disconnect(); }
    }, { rootMargin: '400px 0px' });
    io.observe(el);
    return () => io.disconnect();
  }, [isScripted]);

  useEffect(() => {
    if (!isScripted || !inView) return;
    ensurePreconnect();
    let cancelled = false;
    const el = ref.current;
    // widgets.js inserts the iframe and only then removes the blockquote, so
    // "done" means both: iframe in, scaffolding out.
    const done = () => !!el && !!el.querySelector('iframe') && !el.querySelector('blockquote');
    const src = isTwitter ? 'https://platform.twitter.com/widgets.js' : 'https://www.instagram.com/embed.js';
    const scriptId = isTwitter ? 'lp-twitter-wjs' : 'lp-instagram-ejs';

    // Swap the skeleton out the instant the iframe lands rather than on a timer.
    let mo;
    if (el && typeof MutationObserver !== 'undefined') {
      mo = new MutationObserver(() => {
        if (!cancelled && done()) {
          setHydrated(true);
          mo.disconnect();
          releaseSlotRef.current?.();      // let the next embed start immediately
        }
      });
      mo.observe(el, { childList: true, subtree: true });
    }

    // Held until this embed finishes (or gives up) so the next one can start.
    let slotHeld = false;
    let releaseTimer;
    const freeSlot = () => {
      if (!slotHeld) return;
      slotHeld = false;
      clearTimeout(releaseTimer);
      releaseHydrateSlot();
    };
    releaseSlotRef.current = freeSlot;

    Promise.all([loadScriptOnce(src, scriptId), acquireHydrateSlot()]).then(() => {
      slotHeld = true;
      if (cancelled || !el) { freeSlot(); return; }
      try {
        if (isTwitter && window.twttr?.widgets?.load) window.twttr.widgets.load(el);
        if (isInstagram && window.instgrm?.Embeds?.process) window.instgrm.Embeds.process();
      } catch (e) { /* timeout check below handles it */ }
      if (done()) { setHydrated(true); freeSlot(); }
      // Never let one stuck embed block the queue behind it.
      releaseTimer = setTimeout(freeSlot, 5000);
      // If the platform script didn't hydrate the blockquote into an iframe
      // (blocked embed, private/deleted post, ad-blocker), fall back to the card.
      setTimeout(() => {
        if (!cancelled && el && !el.querySelector('iframe')) setFailed(true);
        freeSlot();
      }, 6000);
    });
    return () => { cancelled = true; if (mo) mo.disconnect(); freeSlot(); };
  }, [isScripted, inView, isTwitter, isInstagram, post.url]);

  if (post.platform === 'twitch') {
    const slug = twitchClipSlug(post.url);
    if (!slug) return <PostCard post={post} />;
    // Twitch classes gambling channels as mature and gates their clip embeds
    // behind a login wall ("this content is intended for certain audiences"),
    // which no parent/domain setting can bypass. An honest link card beats a
    // player that shows a blocked message to every logged-out visitor.
    return (
      <a
        className="lp-embed lp-embed-twitchcard"
        href={post.url}
        target="_blank"
        rel="noopener noreferrer"
      >
        <span className="lp-twitchcard-play">
          <svg viewBox="0 0 24 24" fill="currentColor" width="26" height="26"><path d="M8 5v14l11-7z" /></svg>
        </span>
        <span className="lp-twitchcard-body">
          <span className="lp-twitchcard-kicker">
            <svg viewBox="0 0 24 24" fill="currentColor" width="13" height="13"><path d="M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.571 11.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714z" /></svg>
            Twitch clip
          </span>
          <span className="lp-twitchcard-title">{post.title || 'Watch the clip'}</span>
          <span className="lp-twitchcard-cta">Watch on Twitch →</span>
        </span>
      </a>
    );
  }
  if (post.platform === 'youtube') {
    const id = youtubeId(post.url);
    if (!id) return <PostCard post={post} />;
    const isShort = /\/shorts\//.test(post.url);
    return (
      <div className={`lp-embed lp-embed-yt ${isShort ? 'short' : ''}`}>
        <iframe
          src={`https://www.youtube.com/embed/${id}`}
          title={post.title || 'YouTube video'}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  if (failed) return <PostCard post={post} />;
  if (isTwitter || isInstagram) {
    return (
      <div className={`lp-embed-wrap${hydrated ? ' is-ready' : ''}`}>
        {!hydrated && <EmbedSkeleton />}
        <div ref={ref} className="lp-embed lp-embed-stage">
          {inView && (isTwitter ? (
            <blockquote className="twitter-tweet" data-theme="dark" data-dnt="true">
              <a href={post.url}>{post.title}</a>
            </blockquote>
          ) : (
            <blockquote
              className="instagram-media"
              data-instgrm-permalink={post.url}
              data-instgrm-version="14"
              style={{ background: 'transparent', border: 0, margin: 0, maxWidth: '540px', minWidth: '250px', width: '100%' }}
            >
              <a href={post.url}>{post.title}</a>
            </blockquote>
          ))}
        </div>
      </div>
    );
  }
  return <PostCard post={post} />;
};

// Mount once (App level) so embeds/cards are styled on every page that uses them
export const EmbedStyles = () => (
  <style>{`
    .lp-embed { display: flex; justify-content: center; width: 100%; }

    /* --- staged embed reveal --- */
    .lp-embed-wrap { position: relative; width: 100%; min-height: 340px; }
    .lp-embed-wrap.is-ready { min-height: 0; }
    /* The blockquote must stay in the DOM for widgets.js to find it, so hide it
       visually rather than unmounting it. */
    .lp-embed-stage { opacity: 0; transition: opacity 0.25s ease; }
    .lp-embed-wrap.is-ready .lp-embed-stage { opacity: 1; }
    /* The <blockquote> is only ever scaffolding for widgets.js — it must never
       be painted, not even during the swap to the iframe. */
    .lp-embed-stage > blockquote { opacity: 0 !important; }

    .lp-embed-skel {
      position: absolute; inset: 0;
      display: flex; flex-direction: column; gap: 0.7rem;
      padding: 1rem;
      border-radius: 14px;
      background: rgba(255,255,255,0.025);
      border: 1px solid rgba(255,255,255,0.07);
      overflow: hidden;
      pointer-events: none;
    }
    .lp-embed-skel::after {
      content: '';
      position: absolute; inset: 0;
      background: linear-gradient(100deg, transparent 20%, rgba(168,85,247,0.10) 50%, transparent 80%);
      transform: translateX(-100%);
      animation: lp-skel-sweep 1.4s ease-in-out infinite;
    }
    @keyframes lp-skel-sweep { to { transform: translateX(100%); } }
    .lp-skel-head { display: flex; align-items: center; gap: 0.6rem; }
    .lp-skel-avatar {
      width: 38px; height: 38px; border-radius: 50%; flex: none;
      background: rgba(255,255,255,0.06);
    }
    .lp-skel-lines { display: flex; flex-direction: column; gap: 0.3rem; flex: 1; }
    .lp-skel-line {
      display: block; height: 10px; border-radius: 5px;
      background: rgba(255,255,255,0.055);
    }
    .lp-skel-line.short { width: 42%; }
    .lp-skel-line.mid   { width: 72%; }
    .lp-skel-line.tiny  { width: 26%; height: 8px; }
    .lp-skel-media {
      flex: 1; min-height: 150px; border-radius: 10px;
      background: rgba(255,255,255,0.04);
    }
    @media (prefers-reduced-motion: reduce) {
      .lp-embed-skel::after { animation: none; }
    }
    .lp-embed .twitter-tweet { margin: 0 !important; }
    .lp-embed-twitchcard {
      display: flex;
      align-items: center;
      gap: 0.9rem;
      width: 100%;
      padding: 1rem 1.1rem;
      border-radius: 16px;
      text-decoration: none;
      background: linear-gradient(135deg, rgba(145,70,255,0.16), rgba(255,255,255,0.03));
      border: 1px solid rgba(145,70,255,0.35);
      transition: border-color 0.15s ease, transform 0.15s ease;
    }
    .lp-embed-twitchcard:hover { border-color: rgba(145,70,255,0.7); transform: translateY(-2px); }
    .lp-twitchcard-play {
      flex: none; width: 46px; height: 46px; border-radius: 50%;
      display: flex; align-items: center; justify-content: center;
      background: #9146FF; color: #fff;
      box-shadow: 0 6px 18px rgba(145,70,255,0.45);
    }
    .lp-twitchcard-body { display: flex; flex-direction: column; gap: 0.15rem; min-width: 0; }
    .lp-twitchcard-kicker {
      display: flex; align-items: center; gap: 0.3rem;
      font-size: 0.64rem; font-weight: 800; letter-spacing: 0.12em; text-transform: uppercase; color: #c4a1ff;
    }
    .lp-twitchcard-title {
      font-size: 0.92rem; font-weight: 700; color: #fff; line-height: 1.25;
      display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;
    }
    .lp-twitchcard-cta { font-size: 0.72rem; font-weight: 600; color: #a1a1aa; }
    .lp-embed-yt {
      aspect-ratio: 16 / 9;
      width: 100%;
      border-radius: 16px;
      overflow: hidden;
      border: 1px solid rgba(255,255,255,0.1);
      background: #000;
    }
    .lp-embed-yt.short {
      aspect-ratio: 9 / 16;
      max-width: 300px;
      margin: 0 auto;
    }
    .lp-embed-yt iframe { width: 100%; height: 100%; display: block; }

    .lp-posts-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(290px, 1fr));
      gap: 1.3rem;
      max-width: 980px;
      margin: 0 auto;
      align-items: start;
    }
    .lp-post-card {
      display: flex;
      flex-direction: column;
      height: 100%;
      border-radius: 18px;
      overflow: hidden;
      text-decoration: none;
      background: linear-gradient(160deg, rgba(255,255,255,0.035), rgba(255,255,255,0.012));
      border: 1px solid rgba(255,255,255,0.08);
      transition: transform 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
    }
    .lp-post-card:hover {
      transform: translateY(-6px) scale(1.02);
      border-color: rgba(168,85,247,0.5);
      box-shadow: 0 18px 45px rgba(0,0,0,0.5), 0 0 34px rgba(168,85,247,0.16);
    }
    .lp-post-img { aspect-ratio: 16 / 9; overflow: hidden; }
    .lp-post-img img { width: 100%; height: 100%; object-fit: cover; transition: transform 0.4s ease; display: block; }
    .lp-post-card:hover .lp-post-img img { transform: scale(1.05); }
    .lp-post-body { padding: 1.3rem 1.4rem 1.5rem; display: flex; flex-direction: column; align-items: flex-start; }
    .lp-post-chip {
      display: inline-flex; align-items: center; gap: 0.4rem;
      font-family: 'Space Mono', monospace;
      font-size: 0.66rem; font-weight: 700;
      letter-spacing: 1.5px; text-transform: uppercase;
      padding: 0.25rem 0.65rem;
      border-radius: 999px;
      background: rgba(255,255,255,0.05);
      border: 1px solid rgba(255,255,255,0.12);
      margin-bottom: 0.85rem;
    }
    .lp-post-chip svg { width: 12px; height: 12px; }
    .lp-post-title { font-family: 'Outfit', sans-serif; font-size: 1.02rem; font-weight: 700; color: #fff; margin: 0 0 0.5rem; line-height: 1.4; }
    .lp-post-desc { color: #a1a1aa; font-size: 0.88rem; line-height: 1.6; margin: 0; }
    .lp-post-go {
      display: inline-block;
      margin-top: 0.7rem;
      font-size: 0.82rem; font-weight: 700;
      color: #c084fc;
      opacity: 0;
      transform: translateX(-6px);
      transition: opacity 0.25s ease, transform 0.25s ease;
    }
    .lp-post-card:hover .lp-post-go { opacity: 1; transform: translateX(0); }
  `}</style>
);
